import {css} from 'styled-components';

export default css`
	[motif-theme='light'],
	.motif-theme-light,
	[motif-theme='dark'],
	.motif-theme-dark {
		--primary-font: 'EYInterstate';
		--neon-font-primary: 'EYInterstate';
	}

	html {
		font-size: 14px;
		font-family: var(--primary-font);

		@media only screen and (min-width: 1367px) and (max-width: 1600px) {
			font-size: 12.61px;
		}

		@media only screen and (min-width: 992px) and (max-width: 1366px) {
			font-size: 11.2px;
		}
	}

	body {
		--ds-body-bg: linear-gradient(
			90deg,
			${(props) => props.theme.color['bgGradient1black']},
			${(props) => props.theme.color['bgGradient2greylight100']}
		);
		// set to 1272px because of edge's borders arround the page.
		min-width: 1272px;
	}

	#mount {
		display: flex;
		flex-flow: column;
		height: 100vh;
	}

	* {
		min-width: 0;
	}

	.no-min-width {
		* {
			min-width: unset;
		}
	}
`;
